import React, { useState } from 'react';

const AboutUs = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const industryImages = [
    {
      id: 1,
      src: "/assets/industry/KLM Packaging Industries Factory.png",
      alt: "KLM Packaging Industries Factory Building",
      title: "KLM Factory Building"
    },
    {
      id: 2,
      src: "/assets/products-with-logo/home-about-image1.png",
      alt: "Variety of Packaging Products and Materials",
      title: "Packaging Products Range"
    },
    {
      id: 3,
      src: "/assets/industry/Printing Machinery.png",
      alt: "Advanced Printing and Packaging Machinery",
      title: "Industrial Equipment"
    },
    {
      id: 4,
      src: "/assets/promotional-bags-about-page.png",
      alt: "Promotional Bags and Custom Printed Packaging",
      title: "Promotional Bags"
    },
    {
      id: 5,
      src: "/assets/industry/Industrial Equipment.png",
      alt: "Industrial Packaging Equipment and Machinery",
      title: "Printing Machinery"
    }
  ];

  return (
    <div className="about-us-section">
      {/* Hero Section */}
      <div 
        className="hero-section position-relative d-flex align-items-center justify-content-center text-center text-white"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/banner-images/yellow-bag-sits-wooden-table-store.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',
          borderRadius: '0 0 50px 50px'
        }}
      >
        <div className="container">
          <h1 className="display-4 fw-bold mb-3">About Us</h1>
          {/* <p className="lead mb-4">Carry Green, Choose Paper</p> */}
        </div>
      </div>

      {/* Main Content Section */}
      <div className="container py-5">
        {/* Content Text */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10 text-center">
            <p className="text-muted mb-4" style={{ lineHeight: '1.8', fontSize: '1.1rem' }}>
              KLM Packaging Industries is manufacturers of
              printed and plain paper bags (brown & white),
              sos bags (brown & white), courier bags, packaging products. we are equipped with
              a fully automatic bag making and printing machines,
              not only that, but we deliver products
              of the best quality, price, service and reliability.
              KLM believes in customer satisfaction and
              leaves no stone unturned to
              give the best services in the industry.
            </p>
          </div>
        </div>

        {/* Heading */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-10 text-center">
            <h2 className="fw-bold mb-4" style={{ color: '#2c3e50', fontSize: '2.2rem' }}>
              CUTTING-EDGE FULLY AUTOMATED MACHINERY DESIGNED<br />
              TO MEET YOUR CUSTOMIZED REQUIREMENTS
            </h2>
          </div>
        </div>

        {/* Images Gallery */}
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="college-gallery">
              <div className="row g-3">
                {/* Large featured image - spans 2 columns */}
                <div className="col-lg-8 col-md-12">
                  <div className="featured-image-card">
                    <img
                      src={industryImages[0].src}
                      alt={industryImages[0].alt}
                      className="featured-image"
                      onClick={() => setSelectedImage(industryImages[0])}
                    />
                    <div className="image-overlay">
                      <div className="overlay-content">
                        <h3 className="overlay-title">{industryImages[0].title}</h3>
                        <div className="overlay-line"></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right column with 2 stacked images */}
                <div className="col-lg-4 col-md-12">
                  <div className="stacked-images">
                    <div className="image-card mb-3">
                      <img
                        src={industryImages[1].src}
                        alt={industryImages[1].alt}
                        className="gallery-image"
                        onClick={() => setSelectedImage(industryImages[1])}
                      />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h5 className="overlay-title">{industryImages[1].title}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="image-card">
                      <img
                        src={industryImages[2].src}
                        alt={industryImages[2].alt}
                        className="gallery-image"
                        onClick={() => setSelectedImage(industryImages[2])}
                      />
                      <div className="image-overlay">
                        <div className="overlay-content">
                          <h5 className="overlay-title">{industryImages[2].title}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom row with 2 images */}
                <div className="col-lg-6 col-md-6">
                  <div className="image-card">
                    <img
                      src={industryImages[3].src}
                      alt={industryImages[3].alt}
                      className="gallery-image"
                      onClick={() => setSelectedImage(industryImages[3])}
                    />
                    <div className="image-overlay">
                      <div className="overlay-content">
                        <h5 className="overlay-title">{industryImages[3].title}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="image-card">
                    <img
                      src={industryImages[4].src}
                      alt={industryImages[4].alt}
                      className="gallery-image"
                      onClick={() => setSelectedImage(industryImages[4])}
                    />
                    <div className="image-overlay">
                      <div className="overlay-content">
                        <h5 className="overlay-title">{industryImages[4].title}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for enlarged image view */}
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div className="modal-backdrop"></div>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="modal-image"
            />
            <div className="modal-info">
              <h4>{selectedImage.title}</h4>
            </div>
          </div>
        </div>
      )}

      <style>{`
        /* College Gallery Styles */
        .college-gallery {
          max-width: 1400px;
          margin: 0 auto;
          padding: 20px;
        }

        /* Featured Image Card */
        .featured-image-card {
          position: relative;
          height: 500px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
          transform: perspective(1000px) rotateX(2deg);
          transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          cursor: pointer;
        }

        .featured-image-card:hover {
          transform: perspective(1000px) rotateX(0deg) translateY(-10px);
          box-shadow: 0 30px 60px rgba(0, 0, 0, 0.25);
        }

        .featured-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.2s ease;
        }

        .featured-image-card:hover .featured-image {
          transform: scale(1.05);
          filter: brightness(1.1);
        }

        /* Regular Image Cards */
        .image-card {
          position: relative;
          height: 240px;
          border-radius: 15px;
          overflow: hidden;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
          transition: all 0.15s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          cursor: pointer;
        }

        .image-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
        }

        .stacked-images .image-card:nth-child(1) {
          transform: rotate(-1deg);
        }

        .stacked-images .image-card:nth-child(2) {
          transform: rotate(1deg);
        }

        .stacked-images .image-card:hover {
          transform: rotate(0deg) translateY(-8px) scale(1.02);
        }

        .gallery-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.2s ease;
        }

        .image-card:hover .gallery-image {
          transform: scale(1.08);
          filter: brightness(1.1) contrast(1.1);
        }

        /* Image Overlays */
        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            135deg,
            rgba(220, 53, 69, 0.8) 0%,
            rgba(255, 107, 107, 0.6) 50%,
            rgba(0, 0, 0, 0.7) 100%
          );
          opacity: 0;
          transition: all 0.15s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .image-card:hover .image-overlay,
        .featured-image-card:hover .image-overlay {
          opacity: 1;
        }

        .overlay-content {
          text-align: center;
          color: white;
          transform: translateY(20px);
          transition: all 0.15s ease;
        }

        .image-card:hover .overlay-content,
        .featured-image-card:hover .overlay-content {
          transform: translateY(0);
        }

        .overlay-title {
          font-weight: 600;
          margin-bottom: 10px;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
        }

        .featured-image-card .overlay-title {
          font-size: 2rem;
        }

        .image-card .overlay-title {
          font-size: 1.2rem;
        }

        .overlay-line {
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, #fff, rgba(255, 255, 255, 0.5));
          margin: 0 auto;
          border-radius: 2px;
        }

        /* Modal Styles */
        .image-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: fadeIn 0.3s ease;
        }

        .modal-backdrop {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.9);
          backdrop-filter: blur(10px);
        }

        .modal-content {
          position: relative;
          max-width: 90vw;
          max-height: 90vh;
          background: white;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 50px 100px rgba(0, 0, 0, 0.5);
          animation: modalSlideIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .modal-close {
          position: absolute;
          top: 20px;
          right: 20px;
          width: 50px;
          height: 50px;
          background: rgba(255, 255, 255, 0.9);
          border: none;
          border-radius: 50%;
          font-size: 24px;
          font-weight: bold;
          cursor: pointer;
          z-index: 10;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-close:hover {
          background: white;
          transform: rotate(90deg);
        }

        .modal-image {
          width: 100%;
          height: auto;
          max-height: 70vh;
          object-fit: contain;
        }

        .modal-info {
          padding: 20px 30px;
          text-align: center;
          background: linear-gradient(135deg, #f8f9fa, #e9ecef);
        }

        .modal-info h4 {
          color: #dc3545;
          margin: 0;
          font-size: 1.5rem;
        }

        /* Animations */
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: scale(0.8) translateY(50px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        /* Responsive Design */
        @media (max-width: 991.98px) {
          .featured-image-card {
            height: 350px;
            margin-bottom: 20px;
          }
          
          .image-card {
            height: 200px;
            margin-bottom: 15px;
          }
          
          .stacked-images .image-card {
            transform: none;
          }
        }

        @media (max-width: 767.98px) {
          .college-gallery {
            padding: 10px;
          }
          
          .featured-image-card {
            height: 280px;
            transform: none;
          }
          
          .image-card {
            height: 180px;
          }
          
          .featured-image-card .overlay-title {
            font-size: 1.5rem;
          }
          
          .image-card .overlay-title {
            font-size: 1rem;
          }
        }

        @media (max-width: 575.98px) {
          .featured-image-card {
            height: 250px;
          }
          
          .image-card {
            height: 150px;
          }
          
          .modal-content {
            max-width: 95vw;
            margin: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutUs;